import { http } from "@/shared/lib/api/http"

import type { ListProductFeaturesResponseDto } from "@/features/product-features/model/product-feature-types"

export async function listProductFeatures(locale: string): Promise<ListProductFeaturesResponseDto> {
  const response = await http.get<ListProductFeaturesResponseDto>("/features", { params: { locale } })
  return response.data
}

/**
 * Tell the server this user has now opened a feature.
 *
 * Fire-and-forget by design: a "New" badge that failed to clear is a cosmetic annoyance, and blocking a
 * page transition on it — or showing an error toast about a badge — would be worse than the badge.
 */
export async function markProductFeatureSeen(key: string): Promise<void> {
  await http.post(`/features/${encodeURIComponent(key)}/seen`, {})
}
